var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "navbar_mobile"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "20px"
    },
    attrs: {
      "src": require("@/assets/explorer_logo_".concat(_vm.logoColor, ".png"))
    }
  }), _c('h1', [_c('span', {
    staticClass: "hide"
  }, [_vm._v("Avalanche Explorer")])])])], 1), _c('div', {
    staticClass: "buttons"
  }, [_c('NetworkMenu'), _c('v-btn', {
    staticClass: "search_btn",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        _vm.isSearch = !_vm.isSearch;
      }
    }
  }, [_c('fa', {
    attrs: {
      "icon": "search"
    }
  })], 1), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        _vm.isDrawer = !_vm.isDrawer;
      }
    }
  }, [_c('fa', {
    attrs: {
      "icon": "bars"
    }
  })], 1)], 1)]), _c('v-navigation-drawer', {
    staticStyle: {
      "z-index": "999"
    },
    attrs: {
      "fixed": ""
    },
    model: {
      value: _vm.isDrawer,
      callback: function callback($$v) {
        _vm.isDrawer = $$v;
      },
      expression: "isDrawer"
    }
  }, [_c('v-list', {
    attrs: {
      "dense": "",
      "nav": ""
    }
  }, [_c('v-list-item', [_c('div', {
    staticClass: "drawer_img_container"
  }, [_c('img', {
    staticClass: "drawer_img",
    attrs: {
      "src": require("@/assets/explorer_logo_".concat(_vm.logoColor, ".png"))
    }
  })])]), [_c('v-list-item', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")]), _c('v-list-item', {
    attrs: {
      "to": "/subnets"
    }
  }, [_vm._v("Subnets")]), _c('v-list-item', {
    attrs: {
      "to": "/validators"
    }
  }, [_vm._v("Validators")]), _c('v-list-item', {
    attrs: {
      "href": _vm.tokensURL
    }
  }, [_vm._v("Tokens")]), _c('v-list-item', {
    attrs: {
      "to": "/blockchains"
    }
  }, [_vm._v("Blockchains")]), _c('v-list-item', {
    attrs: {
      "to": "/tx"
    }
  }, [_vm._v("Transactions")]), _vm.isMainnet ? _c('v-list-item', {
    attrs: {
      "href": _vm.statsURL
    }
  }, [_vm._v("Stats")]) : _vm._e(), _c('v-list-item', {
    attrs: {
      "href": _vm.cChainURL
    }
  }, [_vm._v("C-Chain")]), _c('v-list-item', {
    attrs: {
      "href": _vm.statusPageURL
    }
  }, [_vm._v("Status")]), _c('v-list-item', {
    attrs: {
      "to": "/resources"
    }
  }, [_vm._v("Resources")])]], 2)], 1), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "hide-overlay": "",
      "transition": "dialog-bottom-transition"
    },
    model: {
      value: _vm.isSearch,
      callback: function callback($$v) {
        _vm.isSearch = $$v;
      },
      expression: "isSearch"
    }
  }, [_c('v-card', [_vm.isSearch ? _c('div', {
    staticClass: "search_container"
  }, [_c('SearchBarMobile', {
    staticClass: "search_bar",
    attrs: {
      "placeholder": "Search by Address / TxId / Asset"
    },
    on: {
      "search": _vm.onsearch,
      "change": _vm.closeSearch
    }
  })], 1) : _vm._e()])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }